var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path2, _path3, _circle, _path4, _rect10, _rect11, _rect12, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarketNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.4556,
    y: 128.107,
    width: 282.781,
    height: 213.769,
    rx: 12,
    fill: "#393939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6543 288.445L103.032 271.98H114.823L126.615 260.125H135.786L147.68 244.609L158.059 260.125H175.092L188.193 224.561H207.846L220.293 187.021H236.67L245.665 224.561H259.598L272.7 205.462H285.147L291.698 224.561H304.8L315.936 214.024H329.038",
    stroke: "#C9B3FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.6543,
    y: 318.311,
    width: 40.3973,
    height: 3.36644,
    rx: 1.68322,
    fill: "#555050"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86.6543,
    y: 148.307,
    width: 100.993,
    height: 6.73288,
    rx: 3.36644,
    fill: "#EEE7FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86.6543,
    y: 163.455,
    width: 50.4966,
    height: 6.73288,
    rx: 3.36644,
    fill: "#555050"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 221.312,
    y: 318.311,
    width: 40.3973,
    height: 3.36644,
    rx: 1.68322,
    fill: "#555050"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 153.983,
    y: 318.311,
    width: 40.3973,
    height: 3.36644,
    rx: 1.68322,
    fill: "#C9B3FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 288.641,
    y: 318.311,
    width: 40.3973,
    height: 3.36644,
    rx: 1.68322,
    fill: "#555050"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140.517,
    y: 185.338,
    width: 1.68322,
    height: 112.776,
    rx: 0.841611,
    fill: "#EEE7FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 308.84,
    y: 87.7109,
    width: 80.7946,
    height: 80.7946,
    rx: 12,
    fill: "#8C52FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352.23 140.73H345.957C345.871 140.731 345.788 140.762 345.724 140.82C345.66 140.877 345.619 140.956 345.61 141.042C345.594 141.171 345.587 141.302 345.587 141.432C345.587 142.362 345.957 143.254 346.614 143.911C347.272 144.569 348.164 144.939 349.094 144.939C350.024 144.939 350.916 144.569 351.573 143.911C352.231 143.254 352.601 142.362 352.601 141.432C352.601 141.302 352.593 141.171 352.578 141.042C352.569 140.956 352.528 140.877 352.464 140.819C352.4 140.762 352.317 140.73 352.23 140.73Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M362.345 138.314C360.739 135.123 359.901 131.601 359.896 128.029V126.952C359.935 124.862 359.461 122.795 358.515 120.931C357.57 119.067 356.182 117.464 354.473 116.261C353.478 115.619 352.365 115.181 351.199 114.973V113.379C351.199 112.821 350.977 112.286 350.583 111.892C350.188 111.497 349.653 111.275 349.095 111.275C348.537 111.275 348.002 111.497 347.607 111.892C347.213 112.286 346.991 112.821 346.991 113.379V114.991C345.536 115.267 344.166 115.88 342.992 116.782C341.495 118.015 340.295 119.57 339.482 121.331C338.669 123.091 338.263 125.013 338.294 126.952V128.029C338.289 131.601 337.451 135.123 335.845 138.314C335.792 138.42 335.766 138.539 335.772 138.658C335.777 138.778 335.813 138.894 335.875 138.996C335.938 139.097 336.025 139.181 336.13 139.24C336.234 139.298 336.351 139.329 336.471 139.329H361.719C361.839 139.329 361.957 139.298 362.061 139.24C362.165 139.181 362.253 139.097 362.316 138.995C362.379 138.893 362.414 138.777 362.419 138.657C362.424 138.538 362.399 138.419 362.345 138.312V138.314Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 386.268,
    cy: 92.7607,
    r: 13.4658,
    fill: "#C9B3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M385.753 99.4931H388.287V86.0273H386.386L382.901 88.4854L384.168 90.4091L385.753 89.3404V99.4931Z",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1.80981,
    y: 58.4102,
    width: 179.788,
    height: 51.8631,
    rx: 11,
    stroke: "#555050",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7722,
    y: 77.6094,
    width: 90.894,
    height: 3.36644,
    rx: 1.68322,
    fill: "#555050"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 64.7722,
    y: 87.707,
    width: 65.6456,
    height: 3.36644,
    rx: 1.68322,
    fill: "#555050"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9559 92.4272C24.3254 91.7441 24.368 90.6792 25.0511 90.0487L39.5569 76.6587C40.24 76.0281 41.3049 76.0707 41.9354 76.7538C42.566 77.4369 42.5234 78.5018 41.8403 79.1323L27.3344 92.5224C26.6514 93.1529 25.5865 93.1103 24.9559 92.4272Z",
    fill: "#EEE7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6986 92.2031C39.769 92.2031 39.0154 91.4495 39.0154 90.5199L39.0154 79.579L27.0224 79.579C26.0928 79.579 25.3392 78.8254 25.3392 77.8957C25.3392 76.9661 26.0928 76.2125 27.0224 76.2125L40.6986 76.2125C41.6282 76.2125 42.3818 76.9661 42.3818 77.8957L42.3818 90.5199C42.3818 91.4495 41.6282 92.2031 40.6986 92.2031Z",
    fill: "#EEE7FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketNotifications);
export default __webpack_public_path__ + "static/media/market-notifications.806073f664bbd82989a5df80648380ed.svg";
export { ForwardRef as ReactComponent };